// src/store/modules/yourModule/actions.js

import http from '@/plugins/api'
import * as types from './types'
import storage from '@/plugins/storage'
import { startLoading } from '@/helpers/loading'

export default {
  async getBusinessLocation({ commit, dispatch }, sid) {
    const response = await startLoading(dispatch, 'getBusinessLocation', () =>
      http.get(`BusinessQuery/Location?key=${sid}`)
    )
    commit(types.SET_LOCATION, response.data)
  },

  async getDevices({ commit, dispatch }, id) {
    const response = await startLoading(dispatch, 'getDevices', () =>
      http.get(`Device/GetDevices?id=${id}`)
    )
    commit(types.SET_DEVICES, response.data)
  },

  async getRagDeviceTypes({ commit, dispatch }) {
    const response = await startLoading(dispatch, 'getRagDeviceTypes', () =>
      http.get('RAGRating/getRagDeviceTypes')
    )
    commit(types.SET_DEVICE_TYPES, response.data)
  },

  async searchDevices({ dispatch }, search) {
    const response = await startLoading(dispatch, 'searchDevices', () =>
      http.get('Device/GetDevicesForListing', { params: search })
    )
    return response.data
  },

  async loadDevices({ commit }) {
    try {
      const storedDevices = await storage.local.getItem(types.SESSION_DEVICES)
      const devices = storedDevices ? JSON.parse(storedDevices) : []
      commit('SET_DEVICES', devices)
    } catch (error) {
      console.error('Failed to load devices from storage:', error)
      commit('SET_DEVICES', []) // fallback empty array
    }
  },

  async loadDeviceTypes({ commit }) {
    try {
      const storedDeviceTypes = await storage.local.getItem(types.SESSION_DEVICE_TYPES)
      const deviceTypes = storedDeviceTypes ? JSON.parse(storedDeviceTypes) : []
      commit('SET_DEVICE_TYPES', deviceTypes)
    } catch (error) {
      console.error('Failed to load device types from storage:', error)
      commit('SET_DEVICE_TYPES', [])
    }
  }
}
